import {useEffect, useState} from "react";
import {Link, NavLink as NavLinkRRD, useLocation} from "react-router-dom";
import {PropTypes} from "prop-types";
import {
    Col,
    Collapse,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Media,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    Row,
    UncontrolledDropdown,
} from "reactstrap";
import {getAuth, signOut} from "firebase/auth";
import brandImg from "../../assets/img/icons/header/login.png"
import {isSuperAdmin} from "util/Constants";
import activ8Logo from "../../assets/img/brand/activ8gamelogo.png";

var ps;

const Sidebar = (props) => {
    const [collapseOpen, setCollapseOpen] = useState();
    const [loacalRoutes, setLocalRoutes] = useState([]);
    const [id, setId] = useState("");

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const superAdmin = queryParams.get('superAdmin');

    const auth = getAuth();

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName) => {
        return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    };
    // toggles collapse between opened and closed (true/false)
    const toggleCollapse = () => {
        setCollapseOpen((data) => !data);
    };
    // closes the collapse
    const closeCollapse = () => {
        setCollapseOpen(false);
    };
    useEffect(() => {
        if (props.signedInUser.role === "superAdmin") {
            if (superAdmin === isSuperAdmin) {
                const filteredRoutes = routes.map((_route) => {
                    if (!_route.hasOwnProperty('display2')) {
                        return {..._route, display: !_route.display}
                    } else {
                        return {..._route}
                    }
                });
                setLocalRoutes([...filteredRoutes]);
            } else {
                // history.push("/admin/accounts");
                setLocalRoutes([...routes]);
            }
        } else {
            setLocalRoutes([...routes]);
        }
        const eventID = localStorage.getItem("eventId");
        setId(eventID);
    }, [props.location.pathname])
    // creates the links that appear in the left menu / Sidebar
    const createLinks = (routes) => {
        let data = []


        data = loacalRoutes.filter(route => {
            if (route.display) {
                if (props.signedInUser.role === "superAdmin" || props.signedInUser.projectType === "ace") {
                    // if (route.path2 === "/setting") {
                    //     return;
                    // }
                    return true;
                } else if (props.signedInUser.projectType === "progress" && route.name !== "Candidate Report") {
                    return true;
                }
            }
        }).map((prop, key) => {
            return (
                <NavItem key={key}>
                    <NavLink
                        className=""
                        to={superAdmin === isSuperAdmin ? prop.path2 ? prop.layout + prop.path2 + "/" + id + "?superAdmin=" + superAdmin : prop.layout + prop.path : prop.path2 ? prop.layout + prop.path2 + "/" + id : prop.layout + prop.path}
                        tag={NavLinkRRD}
                        onClick={closeCollapse}
                        activeClassName="active"
                    >
                        {prop.path2 && activeRoute(prop.layout + prop.path2 + "/" + id) ?
                            <img className="mx-2" src={prop.icon2}/> : <img className="mx-2" src={prop.icon}/>}
                        {props.signedInUser.projectType === "progress" && prop.name === "Assessor Board"
                            ? "LeaderBoard 2"
                            : prop.name}</NavLink>
                </NavItem>
            );
        });
        return data;


    };

    const {bgColor, routes, logo} = props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
        navbarBrandProps = {
            to: logo.innerLink,
            tag: Link,
        };
    } else if (logo && logo.outterLink) {
        navbarBrandProps = {
            href: logo.outterLink,
            target: "_blank",
        };
    }

    return (
        <Navbar
            style={{background: "#3E5B86"}}
            className="navbar-vertical fixed-left navbar-dark"
            expand="md"
            id="sidenav-main"
        >
            <Container fluid>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                >
                    <span className="navbar-toggler-icon"/>
                </button>
                {/* Brand */}
                {logo ? (
                    <>
                        <NavbarBrand className="pt-0" {...navbarBrandProps}
                                     href={props.signedInUser.role === 'superAdmin' ? '/admin/accounts' : '/assessment/dashboard'}>
                            <img
                                alt={logo.imgAlt}
                                className="navbar-brand-img"
                                src={logo.imgSrc}
                            />
                        </NavbarBrand>
                    </>
                ) : null}
                {/* User */}
                <Nav className="align-items-center d-md-none">
                    <UncontrolledDropdown nav>
                        <DropdownToggle className="pr-0" nav>
                            <Media className="align-items-center">
                                <span className="avatar avatar-sm rounded-circle">
                                    <img
                                        alt="..."
                                        src={brandImg}
                                    />
                                </span>
                            </Media>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem className="noti-title" header tag="div">
                                <h6 className="text-overflow m-0">
                                    <span className="mr-1">Hi,</span>
                                    {
                                        props.signedInUser.name ? props.signedInUser.name :
                                            (props.signedInUser.email && props.signedInUser.email.split('@')[0])
                                    }!
                                </h6>
                            </DropdownItem>
                            <DropdownItem href="#pablo" onClick={(e) => {
                                e.preventDefault();
                                signOut(auth).then(() => {
                                    props.setRouteState("");
                                    // Sign-out successful.
                                }).catch((error) => {
                                    // An error happened.
                                });
                            }}>
                                <i className="ni ni-user-run"/>
                                <span>Logout</span>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Nav>
                {/* Collapse */}
                <Collapse navbar isOpen={collapseOpen}>
                    {/* Collapse header */}
                    <div className="navbar-collapse-header d-md-none">
                        <Row>
                            {logo ? (
                                <Col className="collapse-brand" xs="6">
                                    {logo.innerLink ? (
                                        <Link to={logo.innerLink}>
                                            <img alt={logo.imgAlt} src={logo.imgSrc}/>
                                        </Link>
                                    ) : (
                                        <a href={logo.outterLink}>
                                            <img alt={logo.imgAlt} src={logo.imgSrc}/>
                                        </a>
                                    )}
                                </Col>
                            ) : null}
                            <Col className="collapse-close" xs="6">
                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    onClick={toggleCollapse}
                                >
                                    <span/>
                                    <span/>
                                </button>
                            </Col>
                        </Row>
                    </div>

                    {/* Form */}
                    {/*<Form className="mt-4 mb-3 d-md-none">*/}
                    {/*  <InputGroup className="input-group-rounded input-group-merge">*/}
                    {/*    <Input*/}
                    {/*      aria-label="Search"*/}
                    {/*      className="form-control-rounded form-control-prepended"*/}
                    {/*      placeholder="Search"*/}
                    {/*      type="search"*/}
                    {/*    />*/}
                    {/*    <InputGroupAddon addonType="prepend">*/}
                    {/*      <InputGroupText>*/}
                    {/*        <span className="fa fa-search" />*/}
                    {/*      </InputGroupText>*/}
                    {/*    </InputGroupAddon>*/}
                    {/*  </InputGroup>*/}
                    {/*</Form>*/}

                    {/* Navigation */}
                    <Nav navbar>{createLinks(routes)}</Nav>

                    {/* Divider */}
                    {/*<hr className="my-3" />*/}

                    <Nav className="" navbar>
                        <NavItem className="active-pro active">
                            {/*<span className="text-white">logo</span>*/}
                            <img src={activ8Logo} width="95%"/>
                            {/*<NavLink href="#">*/}
                            {/*    <i className="far fa-copyright" />*/}
                            {/*    {new Date().getFullYear()}{" "} <a href="https://activ8games.com" target="_blank"*/}
                            {/*        className="ml-1">Activ8Games</a>*/}
                            {/*</NavLink>*/}
                        </NavItem>
                    </Nav>
                </Collapse>
            </Container>
        </Navbar>
    );
};

Sidebar.defaultProps = {
    routes: [{}],
};

Sidebar.propTypes = {
    // links that will be displayed inside the component
    routes: PropTypes.arrayOf(PropTypes.object),
    logo: PropTypes.shape({
        // innerLink is for links that will direct the user within the app
        // it will be rendered as <Link to="...">...</Link> tag
        innerLink: PropTypes.string,
        // outterLink is for links that will direct the user outside the app
        // it will be rendered as simple <a href="...">...</a> tag
        outterLink: PropTypes.string,
        // the image src of the logo
        imgSrc: PropTypes.string.isRequired,
        // the alt for the img
        imgAlt: PropTypes.string.isRequired,
    }),
};

export default Sidebar;
